module.exports = __webpack_public_path__ + "assets/img/06.dfde99e9.jpg";